import React, { Component } from "react";
import { Button } from "react-bootstrap";
import {
  getPurchaseOrder,
  updateHeader,
  resendPurchaseOrder
} from "../../actions";
import Header from "./Header";
import POTable from "./POTable";
import "./PurchaseOrder.css";
import StatusModal from "../common/StatusModal";
import Sanckbar from "../common/Sanckbar";
import Spinner from "../common/Spinner";

class PurchaseOrder extends Component {
  state = {
    searchInput: null,
    data: "",
    selectedRow: false,
    isCancellable: false,
    isResendable: false,
    isSaveEnabled: false,
    notificationMsg: ""
  };
  constructor() {
    super();
    this.tableHeader = [
      "view",
      "suffix",
      "status",
      "shipped",
      "arrival",
      "total items",
      "total weight",
      "total units",
      "total cost"
    ];
    this.CHGDTL = {};
    this.changes = {};
  }

  inputPO = param => {
    this.setState({ searchInput: param });
  };
  searchPO = () => {
    this.setState({ data: {} });
    if (!this.state.searchInput) {
      this.setWarningMessage("Nothing to search for");
    } else {
      this.setTransitioMessage(<Spinner msg="Loading..." />);
      this.data = {};
      getPurchaseOrder(this.state.searchInput).then(res => {
        let isResenddable = true;
        this.setTransitioMessage();
        if (res.data.success !== false) {
          for (let i = 0; i < res.data.detail.length; i++) {
            if (res.data.detail[i].status === "R") {
              isResenddable = false;
              break;
            }
          }
          this.setState({ isCancellable: false });
          this.data = res.data.detail;
          isResenddable === true
            ? this.setState({ isResendable: true })
            : this.setState({ isResendable: false });
          if (!res.data.success) {
            this.setState({ data: "" });
            this.setErrorMessage(res.data.messages[0].text);
          } else {
            this.setState({ data: res.data });
          }
        } else {
          this.setErrorMessage(res.data.messages[0].text);
          setTimeout(() => {
            this.setErrorMessage();
          }, 2000);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    }
  };
  handeOpenModal = (param, param2, param3, param4, param5, param6) => {
    this.setState({ modalTitle: param2 });
    this.setState({ modalMsg: param3 });
    this.setState({ modalIcon: param4 });
    this.setState({ modalButtonText: param5 });
    this.setState({ modalButtonText2: param6 });
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
    this.setState({ action: param });
    if (param === "success" || param === "fail") {
      this.setState({ onlyClose: true });
    } else {
      this.setState({ onlyClose: false });
    }
  };
  closeModal(e) {
    this.setState({ modalOpen: false });
  }
  cancelHeaderListItem = param => {
    // eslint-disable-next-line
    this.state.selectedRow.value = "C";
    this.setState({ isCancellable: false });
    this.getRowInfo(this.state.newData, this.state.prevData);
  };
  getRowInfo = (newData, prevData) => {
    newData.parentElement.firstChild.checked = true;
    this.setState({ newData });
    this.setState({ prevData });
    const newDataObj = {
      poNumber: prevData.poNumber,
      suffix: prevData.suffix,
      shipDate: newData.children[3].firstChild.textContent,
      arrivalDate: newData.children[4].firstChild.textContent,
      status:
        newData.children[2].firstChild.value !== undefined
          ? newData.children[2].firstChild.value
          : prevData.poh_status
    };
    const prevDataObj = {
      poNumber: prevData.poNumber,
      suffix: prevData.suffix,
      shipDate: prevData.shipDate,
      arrivalDate: prevData.arrivalDate,
      status: prevData.status
    };
    if (JSON.stringify(prevDataObj) !== JSON.stringify(newDataObj)) {
      this.changes[prevData.poNumber + "-" + prevData.suffix] = newDataObj;
    } else {
      delete this.changes[prevData.poNumber + "-" + prevData.suffix];
    }

    if (Object.keys(this.changes).length < 1) {
      this.setState({ isSaveEnabled: false });
    } else {
      this.setState({ isSaveEnabled: true });
    }
    if (newData.children[2].firstChild.value === "O") {
      this.setState({ isCancellable: true });
    } else {
      this.setState({ isCancellable: false });
    }
    this.setState({ selectedRow: newData.children[2].firstChild });
  };
  getDate = (date, ref) => {
    const arrivalDate = new Date(
      ref.parentElement.children[4].firstChild.textContent
    );
    var shippedDate = new Date(
      ref.parentElement.children[3].firstChild.textContent
    );

    if (!shippedDate) {
      shippedDate = new Date();
    }
    const today = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const formatedDate =
      year +
      "-" +
      (month < 9 ? "0" + (month + 1) : month + 1) +
      "-" +
      (day < 10 ? "0" + day : day);

    switch (ref.id) {
      case "shipped-date":
        if (
          //only today or later
          year > today.getFullYear() ||
          // eslint-disable-next-line
          (year == today.getFullYear() && month > today.getMonth()) ||
          // eslint-disable-next-line
          (year == today.getFullYear() &&
            // eslint-disable-next-line
            month == today.getMonth() &&
            day > today.getDate()) ||
          // eslint-disable-next-line
          (year == today.getFullYear() &&
            // eslint-disable-next-line
            month == today.getMonth() &&
            // eslint-disable-next-line
            day == today.getDate())
        ) {
          if (
            Math.ceil(
              (new Date(formatedDate) - arrivalDate) / (1000 * 3600 * 24)
            ) <= -3
          ) {
            ref.firstChild.textContent = formatedDate;
          } else {
            this.setWarningMessage(
              "Ship and Arrival Dates must be 3 days apart"
            );
          }
        } else {
          this.setWarningMessage("The Ship Date must be today’s date or later");
        }
        break;
      case "arrival-date":
        if (
          Math.ceil(
            (new Date(formatedDate) - shippedDate) / (1000 * 3600 * 24)
          ) >= 3
        ) {
          ref.firstChild.textContent = formatedDate;
        } else {
          this.setWarningMessage("Ship and Arrival Dates must be 3 days apart");
        }
        break;
      default:
        break;
    }

    this.closeModal();
    this.getRowInfo(this.state.newData, this.state.prevData);
  };

  handleSearchPO = () => {
    if (Object.keys(this.changes).length < 1) {
      this.searchPO();
    } else {
      this.areHotChanges();
    }
  };

  resendPO = () => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    resendPurchaseOrder(this.state.searchInput).then(res => {
      this.setTransitioMessage();
      if (res.status === 200 && res.data.success === true) {
        this.setSuccessMessage("PO sent successfully");
        setTimeout(() => {
          this.setSuccessMessage();
        }, 2000);
        this.setState({ isResendable: false });
      } else {
        if(res.data.success === false) {
          this.setErrorMessage(res.data.messages[0].text);
        } else {
          this.setErrorMessage("There was an error sending the PO");
        setTimeout(() => {
          this.setErrorMessage();
        }, 2000);
        }
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };

  saveChanges = (action, state) => {
    var changesArray = [];
    this.setTransitioMessage(<Spinner msg="Saving..." />);
    this.setState({ isSaving: true });
    for (let o = 0; o < Object.keys(this.changes).length; o++) {
      changesArray.push({
        poNumber: this.changes[Object.keys(this.changes)[o]].poNumber,
        suffix: this.changes[Object.keys(this.changes)[o]].suffix,
        shipDate: this.changes[Object.keys(this.changes)[o]].shipDate,
        arrivalDate: this.changes[Object.keys(this.changes)[o]].arrivalDate,
        status: this.changes[Object.keys(this.changes)[o]].status
      });
    }

    this.setState({ filteredRows: false });

    var uId = sessionStorage.getItem("uId");

    var obj = {
      audit: {
        userId: uId
      },
      headerDetails: changesArray
    };

    updateHeader(obj).then(res => {
      if (res.data.success) {
        this.changes = {};
        this.setTransitioMessage();
        this.setState({ isSaving: false });
        setTimeout(() => {
          this.setSuccessMessage("Changes saved!");
          if (action === "redirect") {
            setTimeout(() => {
              this.redirect(state);
            }, 1000);
          }
        }, 1000);
        this.searchPO();
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
    this.closeModal();
    this.setState({ isSaveEnabled: false });
  };

  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };

  setNotification = (text, color, icon, timeout) => {
    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };

  componentDidMount() {
    if (this.props.location.state) {
      this.setState({
        searchInput: this.props.location.state.poh_ponumber
      });
      setTimeout(() => {
        this.searchPO();
      }, 10);
    }
  }

  redirect = state => {
    this.state.data.header.allowAddItem === null ||
    this.state.data.header.allowAddItem === "" ||
    this.state.data.header.allowAddItem === " "
      ? (state.isAddItemAllowed = true)
      : (state.isAddItemAllowed = this.state.data.header.allowAddItem);
    this.props.history.push({
      pathname: "/podetail",
      state
    });
  };
  areHotChanges = state => {
    this.setState({ isModalButtonActive: true });
    this.setState({
      button1Action: e =>
        state ? this.discardChanges("redirect", state) : this.discardChanges(),
      button2Action: e =>
        state ? this.saveChanges("redirect", state) : this.saveChanges()
    });
    this.handeOpenModal(
      "choice",
      "Input...",
      "There are unsaved changes. Please select one of the following actions.",
      "format_list_bulleted",
      "Discard",
      "Save"
    );
  };
  handleRedirect = state => {
    if (Object.keys(this.changes).length < 1) {
      // this.discardChanges();
      this.redirect(state);
    } else {
      this.areHotChanges(state);
    }
  };
  discardChanges = (action, state) => {
    this.changes = {};
    this.closeModal();
    this.setWarningMessage("Changes discarded...");
    setTimeout(() => {
      this.setWarningMessage();

      action === "redirect" ? this.redirect(state) : this.searchPO();
    }, 2000);
  };
  render() {
    return (
      <div className="container-fluid app-container">
        <div className="row justify-content-center">
          <div>
            <h3 className="page-title">Purchase Order Maintenance</h3>
            {/* {this.state.isSearching ? "searching..." : ""} */}
            {/* <p className="error-message">{this.state.errorMsg}</p>
            <p className="success-message">{this.state.successMsg}</p> */}
          </div>
        </div>
        <Header
          enter={this.handleSearchPO}
          onChange={this.inputPO}
          data={this.state.data.header}
          sendErrorMessage={this.setWarningMessage}
          updatedSearchInput={this.state.searchInput}
        />

        <POTable
          updatedSearchInput={this.state.searchInput}
          data={this.state.data.detail}
          poh_number={this.state.data.header}
          getRowInfo={this.getRowInfo}
          tableHeader={this.tableHeader}
          onClick={this.handeOpenModal}
          getDate={this.getDate}
          sendErrorMessage={this.setWarningMessage}
          areUnsavedChanges={this.areUnsavedChanges}
          changes={this.changes}
          redirect={this.handleRedirect}
        />

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isResendable}
              onClick={e => this.resendPO()}
            >
              Resend
            </Button>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isCancellable}
              onClick={e => this.cancelHeaderListItem()}
            >
              Cancel
            </Button>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.saveChanges()}
            >
              Save
            </Button>
          </div>
        </div>
        {/* <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={this.state.action}
          handleOpenClose={e => this.closeModal(e)}
          hasOnlyClose={this.state.onlyClose}
          title={this.state.modalTitle}
          msg={this.state.modalMsg}
          icon={this.state.modalIcon}
          active={this.state.isFormValid}
          buttonText={this.state.modalButtonText}
        /> */}
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={this.state.action}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button1: this.state.button1Action,
            button2: this.state.button2Action
          }}
          hasOnlyClose={this.state.onlyClose}
          title={this.state.modalTitle}
          msg={this.state.modalMsg}
          icon={this.state.modalIcon}
          active={this.state.isModalButtonActive}
          buttonText={this.state.modalButtonText}
          buttonText2={this.state.modalButtonText2}
        />
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
      </div>
    );
  }
}

export default PurchaseOrder;
